const tokens = {
  "colors.text.primary": {
    "value": "var(--_color-primary, light-dark(hsl(225 66.7% 1.2%),hsl(225 100% 99%)))",
    "variable": "var(--colors-text-primary)"
  },
  "colors.text.canvas": {
    "value": "var(--_color-canvas, light-dark(#fff,hsl(225 66.7% 1.2%)))",
    "variable": "var(--colors-text-canvas)"
  },
  "colors.text.contrastHigher": {
    "value": "var(--_color-contrast-higher, light-dark(hsl(240 8.7% 9% / 0.8),hsl(240 12.5% 96.9% / 0.78)))",
    "variable": "var(--colors-text-contrast-higher)"
  },
  "colors.text.contrastHigh": {
    "value": "var(--_color-contrast-high, light-dark(hsl(240 7.1% 11% / 0.7),hsl(240 12.5% 96.9% / 0.67)))",
    "variable": "var(--colors-text-contrast-high)"
  },
  "colors.text.contrastMedium": {
    "value": "var(--_color-contrast-medium, light-dark(hsl(240 6.1% 7% / 0.6),hsl(240 12.5% 96.9% / 0.56)))",
    "variable": "var(--colors-text-contrast-medium)"
  },
  "colors.text.contrastLow": {
    "value": "var(--_color-contrast-low, light-dark(hsl(240 5.3% 14.9% / 0.5),hsl(240 12.5% 96.9% / 0.45)))",
    "variable": "var(--colors-text-contrast-low)"
  },
  "colors.text.info": {
    "value": "var(--_color-info, light-dark(hsl(228 83.2% 51%),hsl(210 100% 54.5%)))",
    "variable": "var(--colors-text-info)"
  },
  "colors.text.success": {
    "value": "var(--_color-success, light-dark(hsl(115 77.5% 27.8%),hsl(157 84.9% 41.6%)))",
    "variable": "var(--colors-text-success)"
  },
  "colors.text.warning": {
    "value": "var(--_color-warning, light-dark(hsl(28 97.7% 34.1%),hsl(28 90.2% 56.1%)))",
    "variable": "var(--colors-text-warning)"
  },
  "colors.text.error": {
    "value": "var(--_color-error, light-dark(hsl(357 78% 41%),hsl(0 96.9% 62%)))",
    "variable": "var(--colors-text-error)"
  },
  "colors.background.canvas": {
    "value": "var(--_color-canvas, light-dark(#fff,hsl(225 66.7% 1.2%)))",
    "variable": "var(--colors-background-canvas)"
  },
  "colors.background.surface": {
    "value": "var(--_color-surface, light-dark(hsl(240 10% 95%),hsl(240 2% 10%)))",
    "variable": "var(--colors-background-surface)"
  },
  "colors.background.frosted": {
    "value": "var(--_color-frosted, light-dark(hsl(240 5% 70% / 0.148),hsl(240 2% 43% / 0.228)))",
    "variable": "var(--colors-background-frosted)"
  },
  "colors.background.frostedSoft": {
    "value": "var(--_color-frosted-soft, light-dark(hsl(234 9.8% 60% / 0.06),hsl(240 3.7% 26.5% / 0.154)))",
    "variable": "var(--colors-background-frosted-soft)"
  },
  "colors.background.frostedStrong": {
    "value": "var(--_color-frosted-strong, light-dark(hsl(236 6.5% 42% / 0.236),hsl(240 1.5% 61.8% / 0.302)))",
    "variable": "var(--colors-background-frosted-strong)"
  },
  "colors.background.backdrop": {
    "value": "var(--_color-backdrop, light-dark(hsl(240 5.3% 14.9% / 0.5),hsl(240 5.3% 14.9% / 0.5)))",
    "variable": "var(--colors-background-backdrop)"
  },
  "colors.background.infoFrosted": {
    "value": "var(--_color-info-frosted, light-dark(hsl(211 100% 90% / 0.55),hsl(210 79% 20% / 0.66)))",
    "variable": "var(--colors-background-info-frosted)"
  },
  "colors.background.infoFrostedSoft": {
    "value": "var(--_color-info-frosted-soft, light-dark(hsl(211 80% 95% / 0.55),hsl(210 59% 15% / 0.66)))",
    "variable": "var(--colors-background-info-frosted-soft)"
  },
  "colors.background.successFrosted": {
    "value": "var(--_color-success-frosted, light-dark(hsl(109 100% 90% / 0.55),hsl(157 79% 20% / 0.66)))",
    "variable": "var(--colors-background-success-frosted)"
  },
  "colors.background.successFrostedSoft": {
    "value": "var(--_color-success-frosted-soft, light-dark(hsl(109 80% 95% / 0.55),hsl(157 59% 15% / 0.66)))",
    "variable": "var(--colors-background-success-frosted-soft)"
  },
  "colors.background.warningFrosted": {
    "value": "var(--_color-warning-frosted, light-dark(hsl(40 100% 90% / 0.55),hsl(52 79% 20% / 0.66)))",
    "variable": "var(--colors-background-warning-frosted)"
  },
  "colors.background.warningFrostedSoft": {
    "value": "var(--_color-warning-frosted-soft, light-dark(hsl(40 80% 95% / 0.55),hsl(52 59% 15% / 0.66)))",
    "variable": "var(--colors-background-warning-frosted-soft)"
  },
  "colors.background.errorFrosted": {
    "value": "var(--_color-error-frosted, light-dark(hsl(0 100% 90% / 0.55),hsl(0 79% 20% / 0.66)))",
    "variable": "var(--colors-background-error-frosted)"
  },
  "colors.background.errorFrostedSoft": {
    "value": "var(--_color-error-frosted-soft, light-dark(hsl(0 80% 95% / 0.55),hsl(0 59% 15% / 0.66)))",
    "variable": "var(--colors-background-error-frosted-soft)"
  },
  "colors.border.primary": {
    "value": "var(--_color-primary, light-dark(hsl(225 66.7% 1.2%),hsl(225 100% 99%)))",
    "variable": "var(--colors-border-primary)"
  },
  "colors.border.canvas": {
    "value": "var(--_color-canvas, light-dark(#fff,hsl(225 66.7% 1.2%)))",
    "variable": "var(--colors-border-canvas)"
  },
  "colors.border.contrastHigher": {
    "value": "var(--_color-contrast-higher, light-dark(hsl(240 8.7% 9% / 0.8),hsl(240 12.5% 96.9% / 0.78)))",
    "variable": "var(--colors-border-contrast-higher)"
  },
  "colors.border.contrastHigh": {
    "value": "var(--_color-contrast-high, light-dark(hsl(240 7.1% 11% / 0.7),hsl(240 12.5% 96.9% / 0.67)))",
    "variable": "var(--colors-border-contrast-high)"
  },
  "colors.border.contrastMedium": {
    "value": "var(--_color-contrast-medium, light-dark(hsl(240 6.1% 7% / 0.6),hsl(240 12.5% 96.9% / 0.56)))",
    "variable": "var(--colors-border-contrast-medium)"
  },
  "colors.border.contrastLow": {
    "value": "var(--_color-contrast-low, light-dark(hsl(240 5.3% 14.9% / 0.5),hsl(240 12.5% 96.9% / 0.45)))",
    "variable": "var(--colors-border-contrast-low)"
  },
  "colors.border.contrastLower": {
    "value": "var(--_color-contrast-lower, light-dark(hsl(234 6% 32.9% / 0.324),hsl(240 1.5% 61.8% / 0.302)))",
    "variable": "var(--colors-border-contrast-lower)"
  },
  "colors.border.infoMedium": {
    "value": "var(--_color-info-medium, light-dark(hsl(228 83.2% 51% / 0.6),hsl(210 100% 54.5% / 0.6)))",
    "variable": "var(--colors-border-info-medium)"
  },
  "colors.border.infoLow": {
    "value": "var(--_color-info-low, light-dark(hsl(228 83.2% 51% / 0.18),hsl(210 100% 54.5% / 0.18)))",
    "variable": "var(--colors-border-info-low)"
  },
  "colors.border.successMedium": {
    "value": "var(--_color-success-medium, light-dark(hsl(115 77.5% 27.8% / 0.6),hsl(157 84.9% 41.6% / 0.6)))",
    "variable": "var(--colors-border-success-medium)"
  },
  "colors.border.successLow": {
    "value": "var(--_color-success-low, light-dark(hsl(115 77.5% 27.8% / 0.18),hsl(157 84.9% 41.6% / 0.18)))",
    "variable": "var(--colors-border-success-low)"
  },
  "colors.border.warningMedium": {
    "value": "var(--_color-warning-medium, light-dark(hsl(28 97.7% 34.1% / 0.6),hsl(28 90.2% 56.1% / 0.6)))",
    "variable": "var(--colors-border-warning-medium)"
  },
  "colors.border.warningLow": {
    "value": "var(--_color-warning-low, light-dark(hsl(28 97.7% 34.1% / 0.18),hsl(28 90.2% 56.1% / 0.18)))",
    "variable": "var(--colors-border-warning-low)"
  },
  "colors.border.errorMedium": {
    "value": "var(--_color-error-medium, light-dark(hsl(357 78% 41% / 0.6),hsl(0 96.9% 62% / 0.6)))",
    "variable": "var(--colors-border-error-medium)"
  },
  "colors.border.errorLow": {
    "value": "var(--_color-error-low, light-dark(hsl(357 78% 41% / 0.18),hsl(0 96.9% 62% / 0.18)))",
    "variable": "var(--colors-border-error-low)"
  },
  "colors.a11y.focus": {
    "value": "var(--_color-focus, light-dark(#1A44EA,#1A44EA))",
    "variable": "var(--colors-a11y-focus)"
  },
  "radii.xs": {
    "value": "2px",
    "variable": "var(--radii-xs)"
  },
  "radii.sm": {
    "value": "4px",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "6px",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "8px",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "12px",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "16px",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "24px",
    "variable": "var(--radii-3xl)"
  },
  "radii.4xl": {
    "value": "32px",
    "variable": "var(--radii-4xl)"
  },
  "radii.full": {
    "value": "calc(infinity * 1px)",
    "variable": "var(--radii-full)"
  },
  "spacing.grid": {
    "value": "clamp(16px, 1.25vw + 12px, 36px)",
    "variable": "var(--spacing-grid)"
  },
  "spacing.2xs": {
    "value": "1px",
    "variable": "var(--spacing-2xs)"
  },
  "spacing.xs": {
    "value": "4px",
    "variable": "var(--spacing-xs)"
  },
  "spacing.sm": {
    "value": "8px",
    "variable": "var(--spacing-sm)"
  },
  "spacing.md": {
    "value": "16px",
    "variable": "var(--spacing-md)"
  },
  "spacing.lg": {
    "value": "32px",
    "variable": "var(--spacing-lg)"
  },
  "spacing.xl": {
    "value": "48px",
    "variable": "var(--spacing-xl)"
  },
  "spacing.2xl": {
    "value": "80px",
    "variable": "var(--spacing-2xl)"
  },
  "sizes.xxLarge": {
    "value": "80px",
    "variable": "var(--sizes-xx-large)"
  },
  "sizes.2xs": {
    "value": "1px",
    "variable": "var(--sizes-2xs)"
  },
  "sizes.xs": {
    "value": "4px",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "8px",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "16px",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32px",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "48px",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "80px",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.content": {
    "value": "1000px",
    "variable": "var(--sizes-content)"
  },
  "sizes.breakpoint-base": {
    "value": "0px",
    "variable": "var(--sizes-breakpoint-base)"
  },
  "sizes.breakpoint-xs": {
    "value": "480px",
    "variable": "var(--sizes-breakpoint-xs)"
  },
  "sizes.breakpoint-sm": {
    "value": "760px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "1000px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1300px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1760px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-xxl": {
    "value": "1920px",
    "variable": "var(--sizes-breakpoint-xxl)"
  },
  "fontSizes.2xs": {
    "value": ".75rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": ".875rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "1rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "clamp(1.13rem, 0.21vw + 1.08rem, 1.33rem)",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "clamp(1.27rem, 0.51vw + 1.16rem, 1.78rem)",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "clamp(1.42rem, 0.94vw + 1.23rem, 2.37rem)",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "clamp(1.6rem, 1.56vw + 1.29rem, 3.16rem)",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "clamp(1.8rem, 2.41vw + 1.32rem, 4.21rem)",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "clamp(2.03rem, 3.58vw + 1.31rem, 5.61rem)",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "clamp(2.28rem, 5.2vw + 1.24rem, 7.48rem)",
    "variable": "var(--font-sizes-5xl)"
  },
  "zIndex.header": {
    "value": 0,
    "variable": "var(--z-index-header)"
  },
  "zIndex.default": {
    "value": 1,
    "variable": "var(--z-index-default)"
  },
  "zIndex.sidebarOverlay": {
    "value": 8,
    "variable": "var(--z-index-sidebar-overlay)"
  },
  "zIndex.sidebar": {
    "value": 9,
    "variable": "var(--z-index-sidebar)"
  },
  "zIndex.overlay": {
    "value": 10,
    "variable": "var(--z-index-overlay)"
  },
  "zIndex.devTools": {
    "value": 100,
    "variable": "var(--z-index-dev-tools)"
  },
  "zIndex.tooltip": {
    "value": 9999,
    "variable": "var(--z-index-tooltip)"
  },
  "zIndex.popover": {
    "value": 9999,
    "variable": "var(--z-index-popover)"
  },
  "zIndex.toast": {
    "value": 999999,
    "variable": "var(--z-index-toast)"
  },
  "shadows.sm": {
    "value": "0px 3px 8px rgba(0,0,0,.16)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.md": {
    "value": "0px 4px 16px rgba(0,0,0,.16)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "0px 8px 40px rgba(0,0,0,.16)",
    "variable": "var(--shadows-lg)"
  },
  "durations.sm": {
    "value": ".25s",
    "variable": "var(--durations-sm)"
  },
  "durations.md": {
    "value": ".4s",
    "variable": "var(--durations-md)"
  },
  "durations.lg": {
    "value": ".6s",
    "variable": "var(--durations-lg)"
  },
  "durations.xl": {
    "value": "1.2s",
    "variable": "var(--durations-xl)"
  },
  "easings.base": {
    "value": "cubic-bezier(.25,.1,.25,1)",
    "variable": "var(--easings-base)"
  },
  "easings.in": {
    "value": "cubic-bezier(0,0,.2,1)",
    "variable": "var(--easings-in)"
  },
  "easings.out": {
    "value": "cubic-bezier(.4,0,.5,1)",
    "variable": "var(--easings-out)"
  },
  "breakpoints.base": {
    "value": "0px",
    "variable": "var(--breakpoints-base)"
  },
  "breakpoints.xs": {
    "value": "480px",
    "variable": "var(--breakpoints-xs)"
  },
  "breakpoints.sm": {
    "value": "760px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "1000px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1300px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1760px",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.xxl": {
    "value": "1920px",
    "variable": "var(--breakpoints-xxl)"
  },
  "spacing.-grid": {
    "value": "calc(var(--spacing-grid) * -1)",
    "variable": "var(--spacing-grid)"
  },
  "spacing.-2xs": {
    "value": "calc(var(--spacing-2xs) * -1)",
    "variable": "var(--spacing-2xs)"
  },
  "spacing.-xs": {
    "value": "calc(var(--spacing-xs) * -1)",
    "variable": "var(--spacing-xs)"
  },
  "spacing.-sm": {
    "value": "calc(var(--spacing-sm) * -1)",
    "variable": "var(--spacing-sm)"
  },
  "spacing.-md": {
    "value": "calc(var(--spacing-md) * -1)",
    "variable": "var(--spacing-md)"
  },
  "spacing.-lg": {
    "value": "calc(var(--spacing-lg) * -1)",
    "variable": "var(--spacing-lg)"
  },
  "spacing.-xl": {
    "value": "calc(var(--spacing-xl) * -1)",
    "variable": "var(--spacing-xl)"
  },
  "spacing.-2xl": {
    "value": "calc(var(--spacing-2xl) * -1)",
    "variable": "var(--spacing-2xl)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--colors-color-palette-primary)",
    "variable": "var(--colors-color-palette-primary)"
  },
  "colors.colorPalette.canvas": {
    "value": "var(--colors-color-palette-canvas)",
    "variable": "var(--colors-color-palette-canvas)"
  },
  "colors.colorPalette.contrastHigher": {
    "value": "var(--colors-color-palette-contrast-higher)",
    "variable": "var(--colors-color-palette-contrast-higher)"
  },
  "colors.colorPalette.contrastHigh": {
    "value": "var(--colors-color-palette-contrast-high)",
    "variable": "var(--colors-color-palette-contrast-high)"
  },
  "colors.colorPalette.contrastMedium": {
    "value": "var(--colors-color-palette-contrast-medium)",
    "variable": "var(--colors-color-palette-contrast-medium)"
  },
  "colors.colorPalette.contrastLow": {
    "value": "var(--colors-color-palette-contrast-low)",
    "variable": "var(--colors-color-palette-contrast-low)"
  },
  "colors.colorPalette.info": {
    "value": "var(--colors-color-palette-info)",
    "variable": "var(--colors-color-palette-info)"
  },
  "colors.colorPalette.success": {
    "value": "var(--colors-color-palette-success)",
    "variable": "var(--colors-color-palette-success)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--colors-color-palette-warning)",
    "variable": "var(--colors-color-palette-warning)"
  },
  "colors.colorPalette.error": {
    "value": "var(--colors-color-palette-error)",
    "variable": "var(--colors-color-palette-error)"
  },
  "colors.colorPalette.surface": {
    "value": "var(--colors-color-palette-surface)",
    "variable": "var(--colors-color-palette-surface)"
  },
  "colors.colorPalette.frosted": {
    "value": "var(--colors-color-palette-frosted)",
    "variable": "var(--colors-color-palette-frosted)"
  },
  "colors.colorPalette.frostedSoft": {
    "value": "var(--colors-color-palette-frosted-soft)",
    "variable": "var(--colors-color-palette-frosted-soft)"
  },
  "colors.colorPalette.frostedStrong": {
    "value": "var(--colors-color-palette-frosted-strong)",
    "variable": "var(--colors-color-palette-frosted-strong)"
  },
  "colors.colorPalette.backdrop": {
    "value": "var(--colors-color-palette-backdrop)",
    "variable": "var(--colors-color-palette-backdrop)"
  },
  "colors.colorPalette.infoFrosted": {
    "value": "var(--colors-color-palette-info-frosted)",
    "variable": "var(--colors-color-palette-info-frosted)"
  },
  "colors.colorPalette.infoFrostedSoft": {
    "value": "var(--colors-color-palette-info-frosted-soft)",
    "variable": "var(--colors-color-palette-info-frosted-soft)"
  },
  "colors.colorPalette.successFrosted": {
    "value": "var(--colors-color-palette-success-frosted)",
    "variable": "var(--colors-color-palette-success-frosted)"
  },
  "colors.colorPalette.successFrostedSoft": {
    "value": "var(--colors-color-palette-success-frosted-soft)",
    "variable": "var(--colors-color-palette-success-frosted-soft)"
  },
  "colors.colorPalette.warningFrosted": {
    "value": "var(--colors-color-palette-warning-frosted)",
    "variable": "var(--colors-color-palette-warning-frosted)"
  },
  "colors.colorPalette.warningFrostedSoft": {
    "value": "var(--colors-color-palette-warning-frosted-soft)",
    "variable": "var(--colors-color-palette-warning-frosted-soft)"
  },
  "colors.colorPalette.errorFrosted": {
    "value": "var(--colors-color-palette-error-frosted)",
    "variable": "var(--colors-color-palette-error-frosted)"
  },
  "colors.colorPalette.errorFrostedSoft": {
    "value": "var(--colors-color-palette-error-frosted-soft)",
    "variable": "var(--colors-color-palette-error-frosted-soft)"
  },
  "colors.colorPalette.contrastLower": {
    "value": "var(--colors-color-palette-contrast-lower)",
    "variable": "var(--colors-color-palette-contrast-lower)"
  },
  "colors.colorPalette.infoMedium": {
    "value": "var(--colors-color-palette-info-medium)",
    "variable": "var(--colors-color-palette-info-medium)"
  },
  "colors.colorPalette.infoLow": {
    "value": "var(--colors-color-palette-info-low)",
    "variable": "var(--colors-color-palette-info-low)"
  },
  "colors.colorPalette.successMedium": {
    "value": "var(--colors-color-palette-success-medium)",
    "variable": "var(--colors-color-palette-success-medium)"
  },
  "colors.colorPalette.successLow": {
    "value": "var(--colors-color-palette-success-low)",
    "variable": "var(--colors-color-palette-success-low)"
  },
  "colors.colorPalette.warningMedium": {
    "value": "var(--colors-color-palette-warning-medium)",
    "variable": "var(--colors-color-palette-warning-medium)"
  },
  "colors.colorPalette.warningLow": {
    "value": "var(--colors-color-palette-warning-low)",
    "variable": "var(--colors-color-palette-warning-low)"
  },
  "colors.colorPalette.errorMedium": {
    "value": "var(--colors-color-palette-error-medium)",
    "variable": "var(--colors-color-palette-error-medium)"
  },
  "colors.colorPalette.errorLow": {
    "value": "var(--colors-color-palette-error-low)",
    "variable": "var(--colors-color-palette-error-low)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--colors-color-palette-focus)",
    "variable": "var(--colors-color-palette-focus)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar